.item {
  padding: 8px;
  cursor: pointer;
  display: flex;
  min-width: 200px;
}

.item:hover {
  background-color: #eee;
}

.icon {
  width: 20px;
  height: 20px;
  user-select: none;
  margin-right: 12px;
  background-size: contain;
}

.text {
  line-height: 20px;
  flex-grow: 1;
}

.opaque {
  opacity: 0.6;
}
